/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-04-20T19:56:11.021
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseAirCheckItem,
	listRentHouseAirCheckItemInit,
	listRentHouseAirCheckItemByAuthorizations,
	deleteRentHouseAirCheckItem
} from '@api/rentmanage/RentHouseAirCheckItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseAirCheckItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseAirCheckItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseAirCheckItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseAirCheckItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseAirCheckItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseAirCheckItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseAirCheckItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseAirCheckItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
